import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import * as urlService from "../../view/urlService";

const filters = [
    { id: 1, name: "Rule name", key: "rule", component: InputFilter },
    // {id: 2, name: "Description", key: "details", component: InputFilter},
    // {id: 3, name: "Severity", key: "severity", component: SeverityFilter},
    { id: 4, name: "Valid", key: "valid", component: ValidFilter },
]

function RemediationTableSearchSection(
    {
        rule = true,
        details = true,
        severity = true,
        valid = true,
        device = true
    }) {

    const config = { rule, details, severity, valid, device };
    const history = useHistory();
    const [selectedFilter, selectFilter] = useState(filters[0]);
    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        const pageFilters = urlService.getFilters(true);

        if (pageFilters.rule) {
            selectFilter(filters[0])
            setFilterValue(pageFilters.rule)
        }

        if (pageFilters.valid) {
            const validFilter = filters.find(f => f.key === 'valid');
            if (validFilter) {
                selectFilter(validFilter)
                setFilterValue(pageFilters.valid)
            }
        }
    }, [])

    const onFilterTypeChange = (selectedOption) => {
        const value = selectedOption.value;
        setFilterValue('')

        // Remove previous filter from URL
        history.replace({
            pathname: history.pathname,
            search: urlService.removeFilter(selectedFilter.key)
        })

        const filter = filters.find(filter => filter.id === Number(value))
        selectFilter(filter);
    }

    const onSearchChange = (value) => {
        if (value !== '' && value !== null && value !== undefined) {

            if (selectedFilter.key === 'rule') {
                history.replace({
                    pathname: history.pathname,
                    search: urlService.updateSearchFilters(selectedFilter.key, value)
                })
            } else {
                history.replace({
                    pathname: history.pathname,
                    search: urlService.updateFilters(selectedFilter.key, value)
                })
            }
        } else {
            history.replace({
                pathname: history.pathname,
                search: urlService.removeFilter(selectedFilter.key)
            })
        }
        setFilterValue(value);
    }

    const renderFilter = (filter) => {
        const Component = filter.component;
        return <Component onSearchChange={onSearchChange} filterValue={filterValue} />
    }

    // Filter Type Options
    const filterOptions = filters
        .filter(filter => config[filter.key])
        .map(filter => ({ value: filter.id, label: filter.name }));

    return (
        <div>
            <label className="oct_filter-label">Filter/Search</label>
            <div className="oct_filter-row">
                <div>
                    <Select
                        className="oct_selectsearch-v2"
                        classNamePrefix="oct-selectsearchsub-v2"
                        value={filterOptions.find(opt => opt.value === selectedFilter.id)}
                        onChange={onFilterTypeChange}
                        options={filterOptions}
                        isSearchable={false}
                    />
                </div>
                <div className="flex-grow-1">
                    {renderFilter(selectedFilter)}
                </div>
            </div>
        </div>
    )
}

function ValidFilter({ onSearchChange, filterValue }) {
    const options = [
        { value: '', label: 'Select' },
        { value: '1', label: 'Pass' },
        { value: '0', label: 'Fail' },
        { value: '-1', label: 'Unknown' }
    ];

    return (
        <div >
            <Select
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={options.find(opt => opt.value === filterValue) || options[0]}
                onChange={(selectedOption) => onSearchChange(selectedOption.value)}
                options={options}
                isSearchable={false}
            />
        </div>
    )
}

function InputFilter({ onSearchChange, filterValue }) {
    return (
        <div className="form-group mb-0">
            <div className="input-group align-items-center">
                <input className="oct_filter-input-v2 w-100" type="text"
                    aria-label="Search"
                    placeholder="Search..."
                    value={filterValue}
                    onChange={event => onSearchChange(event.target.value)} />
            </div>
        </div>
    )
}

export default RemediationTableSearchSection;
